import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/not-found');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>
}

export default NotFound;